


























































import {defineComponent, onMounted, PropType, ref, SetupContext, toRefs, watch} from "@vue/composition-api"
import {SharedState} from "@/games/scribble/types"

export default defineComponent({
  name: 'PaintArea',
  props: {
    state: {
      type: Object as PropType<SharedState>,
      required: true
    },
    canDraw: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {emit}: SetupContext) {
    const {state, canDraw} = toRefs(props)

    const canvas = ref<HTMLCanvasElement>(null)
    const canvasContainer = ref<HTMLDivElement>(null)
    let context: CanvasRenderingContext2D | null

    let paint = false

    onMounted(() => {
      setTimeout(() => {
        if (!canvas.value || !canvasContainer.value) return

        context = canvas.value.getContext('2d')

        const dim = Math.min(canvasContainer.value.clientWidth, canvasContainer.value.clientHeight)
        context!!.canvas.width = dim
        context!!.canvas.height = dim
      }, 1)
    })
    window.addEventListener('resize', () => {
      redraw()
    })

    watch([canvas, state, canvasContainer], (after, before) => {
      redraw()
    })

    function redraw() {
      if (!context || !canvasContainer.value) return

      const dim = Math.min(canvasContainer.value.clientWidth, canvasContainer.value.clientHeight)
      const width = context.canvas.width = dim
      const height = context.canvas.height = dim

      context.clearRect(0, 0, width, height) // Clears the canva

      context.strokeStyle = "#df4b26"
      context.lineJoin = "round"
      context.lineWidth = 5

      for (let i = 0; i < state.value.draw.clickX.length; i++) {
        context.beginPath()
        if (state.value.draw.clickDrag[i] && i) {
          context.moveTo(state.value.draw.clickX[i - 1] * width, state.value.draw.clickY[i - 1] * height)
        } else {
          context.moveTo((state.value.draw.clickX[i] * width) - 1, state.value.draw.clickY[i] * height)
        }
        context.lineTo(state.value.draw.clickX[i] * width, state.value.draw.clickY[i] * height)
        context.closePath()
        context.stroke()
      }
    }

    function addClick(x: number, y: number, dragging: boolean) {
      if (!canvas.value) return
      const width = canvas.value.width
      const height = canvas.value.height
      state.value.draw.clickX.push(x / width)
      state.value.draw.clickY.push(y / height)
      state.value.draw.clickDrag.push(dragging)

      emit('drawchanged')
    }

    function getTouchPosition(touchEvent: TouchEvent) {
      const rect = canvas.value!!.getBoundingClientRect()
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      }
    }

    return {
      canvas,
      canvasContainer,
      eraseCanvas() {
        state.value.draw.clickX = []
        state.value.draw.clickY = []
        state.value.draw.clickDrag = []
        emit('drawchanged')
        redraw()
      },
      onMouseDown(e: MouseEvent) {
        if (!canDraw.value) return
        paint = true
        addClick(e.offsetX, e.offsetY, false)
        redraw()
      },
      onMouseUp(e: MouseEvent) {
        if (!canDraw.value) return
        paint = false
      },
      onMouseMove(e: MouseEvent) {
        if (!canDraw.value) return
        if (Math.random() > 0.5) return
        console.log(state.value.draw.clickX.length)
        if (paint) {
          addClick(e.offsetX, e.offsetY, true)
          redraw()
        }
      },
      onTouchStart(e: TouchEvent) {
        if (!canDraw.value) return
        paint = true
        const offset = getTouchPosition(e)
        addClick(offset.x, offset.y, false)
        redraw()
      },
      onTouchEnd(e: TouchEvent) {
        if (!canDraw.value) return
        paint = false
      },
      onTouchMove(e: TouchEvent) {
        if (!canDraw.value) return
        if (Math.random() > 0.5) return
        console.log(state.value.draw.clickX.length)
        if (paint) {
          const offset = getTouchPosition(e)
          addClick(offset.x, offset.y, true)
          redraw()
        }
      }
    }
  }
})
